/**
 * Copyright 2022 Phenix Real Time Solutions, Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const SHOW_CONTROLS = 'SHOW_CONTROLS';
const HIDE_CONTROLS = 'HIDE_CONTROLS';
const SET_INTERVAL_ID = 'SET_INTERVAL_ID';
const CLEAR_INTERVAL_ID = 'CLEAR_INTERVAL_ID';
const TOGGLE_VIDEO_QUALITY_SETTINGS_LIST = 'TOGGLE_VIDEO_QUALITY_SETTINGS_LIST';
const SET_VIDEO_QUALITY = 'SET_VIDEO_QUALITY';
const SHOW_VOLUME_SLIDER = 'SHOW_VOLUME_SLIDER';
const HIDE_VOLUME_SLIDER = 'HIDE_VOLUME_SLIDER';
const UPDATE_SEEKBAR_RANGE = 'UPDATE_SEEKBAR_RANGE';
const showControlsAction = (timeoutId) => {
  return {
    type: SHOW_CONTROLS,
    timeoutId
  };
};

const hideControlsAction = () => {
  return {type: HIDE_CONTROLS};
};

const toggleVideoQualitySettingsAction = () => {
  return {type: TOGGLE_VIDEO_QUALITY_SETTINGS_LIST};
};

const showVolumeSliderAction = () => {
  return {type: SHOW_VOLUME_SLIDER};
};

const hideVolumeSliderAction = () => {
  return {type: HIDE_VOLUME_SLIDER};
};

const updateSeekbarRangeAction = (seekbarValues) => {
  return {
    type: UPDATE_SEEKBAR_RANGE,
    seekbarValues
  };
};

const showControlsAndThenHide = (timeoutId, hideControlsDelay) => {
  return function(dispatch) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => dispatch(hideControlsAction()), hideControlsDelay);

    return dispatch(showControlsAction(timeoutId));
  };
};

const setVideoQualitySettingAction = (videoQuality) => {
  return {
    type: SET_VIDEO_QUALITY,
    videoQuality
  };
};

export {
  showControlsAndThenHide,
  hideControlsAction,
  toggleVideoQualitySettingsAction,
  showVolumeSliderAction,
  hideVolumeSliderAction,
  updateSeekbarRangeAction,
  setVideoQualitySettingAction,
  SHOW_CONTROLS,
  HIDE_CONTROLS,
  SET_INTERVAL_ID,
  CLEAR_INTERVAL_ID,
  TOGGLE_VIDEO_QUALITY_SETTINGS_LIST,
  SET_VIDEO_QUALITY,
  SHOW_VOLUME_SLIDER,
  HIDE_VOLUME_SLIDER,
  UPDATE_SEEKBAR_RANGE
};